var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-img",
    _vm._b(
      {
        staticClass: "base-image",
        attrs: { src: _vm.imageSrc },
        scopedSlots: _vm._u(
          [
            {
              key: "placeholder",
              fn: function () {
                return [
                  _c(
                    "v-row",
                    {
                      class: [
                        "base-image__placeholder",
                        "fill-height",
                        _vm.placeholderColorBackground,
                      ],
                      attrs: { align: "center", justify: "center" },
                    },
                    [
                      _vm._t("placeholder", function () {
                        return [
                          _c("v-progress-circular", {
                            staticClass: "base-image__spinner",
                            attrs: {
                              color: _vm.placeholderColorForeground,
                              indeterminate: "",
                            },
                          }),
                        ]
                      }),
                    ],
                    2
                  ),
                ]
              },
              proxy: true,
            },
          ],
          null,
          true
        ),
      },
      "v-img",
      _vm.$attrs,
      false
    ),
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }